export default function HomeFeatures() {
  return (
    <div id="sadrzaj" className="features">
      <h2>Sadržaji</h2>
      <ul>
        <li> Potpuna privatnost u srcu prirode, daleko od gužve i buke</li>
        <li> Savršen spoj luksuznog interijera i udobnog domaćeg ugođaja</li>
        <li>
          {" "}
          Besprijekorna kombinacija modernih sadržaja i prirodnog okruženja
        </li>
        <li>
          {" "}
          Idealan prostor za obitelj, romantične vikende ili povlačenje od
          stresa
        </li>
      </ul>
      <div className="home-features">
        <div className="features-box">
          <i className="fi fi-rs-steak"></i>
          <h5>Roštilj</h5>
        </div>
        <div className="features-box">
          <i className="fi fi-rs-wifi"></i>
          <h5>WiFi</h5>
        </div>
        <div className="features-box">
          <i className="fi fi-rs-forest-alt"></i>
          <h5>Priroda</h5>
        </div>
        <div className="features-box">
          <i className="fi fi-rs-paw"></i>
          <h5>Pet friendly</h5>
        </div>
        <div className="features-box">
          <i className="fi fi-rs-hiking"></i>
          <h5>Planinarenje</h5>
        </div>
        <div className="features-box">
          <i className="fi fi-rs-parking-circle"></i>
          <h5>Parking</h5>
        </div>
        <div className="features-box">
          <i className="fi fi-rs-bed-alt"></i>
          <h5>2 spavaće sobe</h5>
        </div>
        <div className="features-box">
          <i className="fi fi-rs-oven"></i>
          <h5>Kuhinja</h5>
        </div>
        <div className="features-box">
          <i className="fi fi-rs-toilet"></i>
          <h5>Kupaonica</h5>
        </div>
      </div>
    </div>
  );
}
